// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getAnalytics } from "firebase/analytics";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyBznXMPZ9nMDUGBKYvAXs0_XB367cl-Udo",
  authDomain: "paddle-353521.firebaseapp.com",
  databaseURL: "https://paddle-353521-default-rtdb.firebaseio.com",
  projectId: "paddle-353521",
  storageBucket: "paddle-353521.firebasestorage.app",
  messagingSenderId: "687459802562",
  appId: "1:687459802562:web:d7b1ede113723bb3cc0a5b",
  measurementId: "G-GWJGW535P4"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const functions = getFunctions(app);

// Force emulator connection for local testing
try {
  const host = window.location.hostname;
  if (host === "localhost" || host === "127.0.0.1") {
    console.log("Detected localhost, connecting to emulators...");
    connectAuthEmulator(auth, "http://localhost:9099");
    connectFirestoreEmulator(db, 'localhost', 8080);
    connectFunctionsEmulator(functions, 'localhost', 5001);
    console.log("Emulators connected successfully.");
  }
} catch (e) {
  // Ignore "already connected" errors which happen in strict mode or HMR
  console.log("Emulator connection info:", e.message);
}

export { app, auth, analytics, db, functions };

